module.exports = __webpack_public_path__ + "static/media/4ODA15.4a12aa53.jpg";